import _implicitStylesheets from "./mediaCard.css";
import _implicitScopedStylesheets from "./mediaCard.scoped.css?scoped=true";
import _axImage from "ax/image";
import _axIcon from "ax/icon";
import _wdsLink from "wds/link";
import _axCard from "ax/card";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<p type-style="caption" class="media-card__category${0}"${2}>${"t1"}</p>`;
const $fragment2 = parseFragment`<p type-style="body-3" class="media-card__title${0}"${2}>${"t1"}</p>`;
const $fragment3 = parseFragment`<p type-style="caption" class="media-card__subtitle${0}"${2}>${"t1"}</p>`;
const stc0 = {
  props: {
    "padding": "small"
  },
  key: 0
};
const stc1 = {
  classMap: {
    "media-card": true
  },
  key: 1
};
const stc2 = {
  classMap: {
    "media-card__image": true
  },
  key: 2
};
const stc3 = {
  classMap: {
    "media-card__content": true
  },
  key: 4
};
const stc4 = {
  classMap: {
    "media-card__label": true
  },
  key: 7
};
const stc5 = {
  classMap: {
    "media-card__cta": true
  },
  key: 12
};
const stc6 = {
  "media-card__cta-link": true
};
const stc7 = {
  classMap: {
    "media-card__cta-icon": true
  },
  props: {
    "size": "xsmall",
    "icon": "new_window",
    "ariaHidden": "true"
  },
  key: 15
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {c: api_custom_element, h: api_element, d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, t: api_text} = $api;
  return [api_custom_element("ax-card", _axCard, stc0, [api_element("div", stc1, [$cmp.image ? api_element("div", stc2, [api_custom_element("ax-image", _axImage, {
    props: {
      "height": "100%",
      "width": "100%",
      "imgSrc": $cmp.image.url,
      "alt": $cmp.imageAltText
    },
    key: 3
  })]) : null, api_element("div", stc3, [$cmp.category ? api_static_fragment($fragment1, 6, [api_static_part(1, null, api_dynamic_text($cmp.category))]) : null, api_element("div", stc4, [api_static_fragment($fragment2, 9, [api_static_part(1, null, api_dynamic_text($cmp.title))]), $cmp.subtitle ? api_static_fragment($fragment3, 11, [api_static_part(1, null, api_dynamic_text($cmp.subtitle))]) : null]), $cmp.callToAction ? api_element("div", stc5, [api_custom_element("wds-link", _wdsLink, {
    props: {
      "href": $cmp.callToAction.url,
      "name": $cmp.callToAction.label,
      "label": $cmp.callToAction.label
    },
    key: 13
  }, [api_element("a", {
    classMap: stc6,
    attrs: {
      "href": $cmp.callToAction.url,
      "type-style": "caption",
      "aria-label": $cmp.ctaAriaLabel,
      "target": $cmp.ctaTarget,
      "rel": $cmp.ctaRel
    },
    key: 14
  }, [$cmp.isExternalCta ? api_custom_element("ax-icon", _axIcon, stc7) : null, api_text(api_dynamic_text($cmp.callToAction.label))])])]) : null])])])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-3op2ip5o32m";
tmpl.legacyStylesheetToken = "undefined-_mediaCard";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
